module.exports = __webpack_public_path__ + "fonts/eb16815a5bae9f821517ce000035a33c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/scenes/Quote/img/arrow-alt-left.svg
// module id = 2027
// module chunks = 0